import { FC } from 'react';
import {
  RootState,
  chatSelectors,
  useAppSelector,
} from '@vs-online-only-app/state';
import { Stack, Typography } from '@mui/material';
import MessageComposerSharedProductsCarousel from './MessageComposerSharedProductsCarousel';
import { Link } from '@vs-online-only-app/ui';

type Props = {
  maxHeight: number;
};

const MessageComposerSharedProducts: FC<Props> = ({ maxHeight }) => {
  const selectedConversation = useAppSelector(
    chatSelectors.selectSelectedConversation,
  );

  const sharedProducts = useAppSelector((state: RootState) =>
    selectedConversation
      ? chatSelectors.selectConversationSharedProducts(
          state,
          selectedConversation.id,
        )
      : [],
  );

  if (!sharedProducts.length) {
    return null;
  }

  return (
    <Stack gap={1}>
      <Stack gap={0.5}>
        {sharedProducts.map((product) => (
          <Link
            key={product.url}
            target="_blank"
            to={product.url}
            fontFamily="inherit"
          >
            <Typography component="span" variant="caption">
              {product.url}
            </Typography>
          </Link>
        ))}
      </Stack>
      <MessageComposerSharedProductsCarousel products={sharedProducts} />
    </Stack>
  );
};

export default MessageComposerSharedProducts;
